exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".face-element-wrapper img[data-v-097361f2]{max-width:90px}", ""]);

// exports
